import script from "./EditableProductItem.vue?vue&type=script&setup=true&lang=js"
export * from "./EditableProductItem.vue?vue&type=script&setup=true&lang=js"

import "./EditableProductItem.vue?vue&type=style&index=0&id=65deac98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65deac98"]])

export default __exports__